import { BlockControls } from '@wordpress/block-editor';
import PromptsList from '../components/promptsList';
export default function toolBar() {
	return (
		<BlockControls group="block">
			<PromptsList />
		</BlockControls>
	)
}
